exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":root{--main-basic-color:#2196f3;--main-basic-font-color:#fff;--main-basic-hover-color:#1565c0;--main-basic-bd-hover-color:#eef7fe;--main-head-color:#1565c0;--main-head-font-color:#fff;--main-bg-color:#eef7fe;--main-ans-color:#fff;--main-ans-font-color:#333;--main-ans-bord-color:#eef7fe;--main-qry-color:#2196f3;--main-qry-font-color:#fff;--main-qry-bord-color:#eef7fe}.dynamic_demo{overflow:hidden}.scroller{height:100%}.bot_btnset.half:after{display:table;content:\"\";clear:both}.bot_cont_item.bot_text{display:table!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-78f85110","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/uikit/components/IcAnsMessage/IcAnsMessage.vue
// module id = 482
// module chunks = 0